import type { GoogleAdsLeadIntegration, GoogleAdsLeadSeenColumn, GoogleAdsLeadWrite } from '../services/GoogleAdsLeadService';

export type LeadSourceType = 'google_ads' | 'site_form' | 'other';

export const SOURCE_TYPE_OPTIONS: { value: LeadSourceType; label: string }[] = [
  { value: 'google_ads', label: 'Google Ads' },
  { value: 'site_form', label: 'Formulário do site' },
  { value: 'other', label: 'Outra integração' },
];

export type Draft = {
  name: string;
  enabled: boolean;
  columnId: string;
  assigneeId: string;
  country: string;
  /** '' = integração antiga sem tipo definido: o perfil não é alterado ao salvar. */
  sourceType: LeadSourceType | '';
  sourceLabel: string;
  nameColumnId: string;
  phoneColumnId: string;
  emailColumnId: string;
};

export const emptyDraft = (): Draft => ({
  name: 'Formulário',
  enabled: true,
  columnId: '',
  assigneeId: '',
  country: '',
  sourceType: 'google_ads',
  sourceLabel: '',
  nameColumnId: '',
  phoneColumnId: '',
  emailColumnId: '',
});

export function draftFromIntegration(integration: GoogleAdsLeadIntegration): Draft {
  const type = integration.sourceType;
  return {
    name: integration.name,
    enabled: integration.enabled,
    columnId: integration.columnId ? String(integration.columnId) : '',
    assigneeId: integration.assignedTo ? String(integration.assignedTo) : '',
    country: integration.defaultPhoneCountry ?? '',
    sourceType: type === 'google_ads' || type === 'site_form' || type === 'other' ? type : '',
    sourceLabel: integration.sourceLabel ?? '',
    nameColumnId: integration.nameColumnId ?? '',
    phoneColumnId: integration.phoneColumnId ?? '',
    emailColumnId: integration.emailColumnId ?? '',
  };
}

export function validateDraft(draft: Draft): string | null {
  if (!draft.name.trim()) return 'Dê um nome para a integração.';
  if (draft.sourceType === 'other' && !draft.sourceLabel.trim()) return 'Dê um nome para a integração (ex.: RD Station).';
  return null;
}

const orNull = (value: string) => (value.trim() ? value.trim() : null);

export function writeFromDraft(sectorId: number, draft: Draft): GoogleAdsLeadWrite {
  const hasType = draft.sourceType !== '';
  return {
    sectorId,
    name: draft.name.trim(),
    enabled: draft.enabled,
    columnId: draft.columnId ? Number(draft.columnId) : null,
    assignedTo: draft.assigneeId ? Number(draft.assigneeId) : null,
    defaultPhoneCountry: draft.country || null,
    sourceType: hasType ? draft.sourceType : null,
    sourceLabel: draft.sourceType === 'other' ? orNull(draft.sourceLabel) : null,
    nameColumnId: hasType ? orNull(draft.nameColumnId) : null,
    phoneColumnId: hasType ? orNull(draft.phoneColumnId) : null,
    emailColumnId: hasType ? orNull(draft.emailColumnId) : null,
  };
}

/** Opções de um seletor de campo: "{nome} ({id})", ou só o id quando o envio não trouxe nome. Mantém o campo já escolhido. */
export function seenColumnOptions(
  seen: GoogleAdsLeadSeenColumn[],
  current: string,
): { value: string; label: string }[] {
  const options = seen.map((column) => ({
    value: column.columnId,
    label: column.columnName ? `${column.columnName} (${column.columnId})` : column.columnId,
  }));
  if (current && !options.some((option) => option.value === current)) options.push({ value: current, label: current });
  return options;
}
